import { useParams } from 'react-router-dom';
import { FeeRunDetail } from '@/features/fee-runs/fee-run-detail';

const FeeRunDetailPage = () => {
  const { runId } = useParams();

  return (
    <div className="flex w-full flex-col gap-4">
      <FeeRunDetail runId={runId ?? ''} />
    </div>
  );
};
FeeRunDetailPage.displayName = 'FeeRunDetailPage';

export default FeeRunDetailPage;
